// Components
import registerSketch from '../../../../common/drawings/sketches/index';
import presentationalComponent from './Sketch';
import containerComponent from './SketchContainer';
import modalComponent from './modal/LoadableSketchModal';

// Constants
import { TOOLS } from '../../../workspace/toolbar/toolbarConstants';

export default () =>
    registerSketch({
        presentationalComponent,
        containerComponent,
        modalComponent,
        tools: [
            {
                ...TOOLS.COLOR,
                name: 'Background',
            },
            TOOLS.EDIT_DRAWING,
            TOOLS.CAPTION,
            TOOLS.REACTION,
        ],
    });
